// extracted by mini-css-extract-plugin
export default {"container":"settlements_container__0mmSL","content":"settlements_content__TSvHW"};